// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Clsx from "clsx";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as TailwindMerge from "tailwind-merge";
import * as JsxRuntime from "react/jsx-runtime";

var make = React.forwardRef(function (props, ref) {
      var __children = props.children;
      var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: children,
                        ref: Core__Option.map((ref == null) ? undefined : Caml_option.some(ref), (function (prim) {
                                return prim;
                              })),
                        className: "embla__viewport overflow-hidden w-full"
                      }),
                  className: "embla relative w-full"
                });
    });

var Root = {
  make: make
};

function EmblaCarousel$Container(props) {
  var __className = props.className;
  var __children = props.children;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: children,
              ref: props.containerRef,
              className: Clsx.clsx("embla__container flex touch-pan-y w-full", className)
            });
}

var Container = {
  make: EmblaCarousel$Container
};

function EmblaCarousel$Slide(props) {
  var __className = props.className;
  var __children = props.children;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: children,
              className: Clsx.clsx("embla__slide flex-[0_0_100%]", className)
            });
}

var Slide = {
  make: EmblaCarousel$Slide
};

function EmblaCarousel$Prev(props) {
  var __className = props.className;
  var __children = props.children;
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : true;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("button", {
              children: children,
              className: Clsx.clsx("embla__button embla__button--prev appearance-none touch-manipulation no-underline cursor-pointer", TailwindMerge.twMerge("absolute z-10 top-1/2 -translate-y-1/2 left-4", className)),
              disabled: disabled,
              type: "button",
              onClick: props.onClick
            });
}

var Prev = {
  make: EmblaCarousel$Prev
};

function EmblaCarousel$Next(props) {
  var __className = props.className;
  var __children = props.children;
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : true;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("button", {
              children: children,
              className: Clsx.clsx("embla__button embla__button-next appearance-none touch-manipulation no-underline cursor-pointer", TailwindMerge.twMerge("absolute z-10 top-1/2 -translate-y-1/2 right-4", className)),
              disabled: disabled,
              onClick: props.onClick
            });
}

var Next = {
  make: EmblaCarousel$Next
};

function EmblaCarousel$Thumbs$Root(props) {
  var __className = props.className;
  var __children = props.children;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: children,
                    ref: props.viewportRef,
                    className: "embla-thumbs__viewport"
                  }),
              className: TailwindMerge.twMerge("embla-thumbs w-full mt-3", className)
            });
}

var Root$1 = {
  make: EmblaCarousel$Thumbs$Root
};

function EmblaCarousel$Thumbs$Container(props) {
  var __children = props.children;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx("div", {
              children: children,
              className: "embla-thumbs__container flex"
            });
}

var Container$1 = {
  make: EmblaCarousel$Thumbs$Container
};

function EmblaCarousel$Thumbs$Slide(props) {
  var __className = props.className;
  var __children = props.children;
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: children,
              className: Clsx.clsx("embla-thumbs__slide", className),
              onClick: props.onClick
            });
}

var Slide$1 = {
  make: EmblaCarousel$Thumbs$Slide
};

var Thumbs = {
  Root: Root$1,
  Container: Container$1,
  Slide: Slide$1
};

var Api;

export {
  Api ,
  Root ,
  Container ,
  Slide ,
  Prev ,
  Next ,
  Thumbs ,
}
/* make Not a pure module */
